import { Button, Stack, TextField, Typography } from "@mui/material"
import modalEmitter from "../ModalComponent/modalEmitter"
import { useCreateProjectJoinRequestMutation } from "../../api/projects"
import { toast } from "react-toastify"
import React from "react"
import { extractApiErrorMessage } from "../../utils/api"

type JoinProjectModalBodyProps = {
  projectId: number
}

export const JoinProjectModalBody = ({ projectId }: JoinProjectModalBodyProps) => {
  const [createJoinRequest, { isLoading }] = useCreateProjectJoinRequestMutation()
  const [message, setMessage] = React.useState("")

  const handleConfirm = async () => {
    try {
      const trimmed = message.trim()
      await createJoinRequest({ projectId, ...(trimmed.length > 0 ? { message: trimmed } : {}) }).unwrap()
      toast.success("Заявка отправлена")
      modalEmitter.emitCloseModal()
    } catch (error) {
      toast.error(extractApiErrorMessage(error) ?? "Не удалось отправить заявку")
    } finally {
    }
  }

  return (
    <Stack gap={2}>
      <Typography>Вы хотите присоединиться к проекту?</Typography>
      <Typography variant="black-14-light">Сообщение (необязательно)</Typography>
      <TextField
        placeholder="Напишите кратко, чем можете быть полезны"
        multiline
        minRows={4}
        value={message}
        onChange={(e) => setMessage(e.target.value.slice(0, 500))}
        helperText={`${message.length}/500`}
        disabled={isLoading}
        fullWidth
      />
      <Stack direction="row" gap={2} justifyContent="flex-end">
        <Button
          variant="action"
          disabled={isLoading}
          onClick={handleConfirm}
        >
          Присоединиться
        </Button>
      </Stack>
    </Stack>
  )
}
